import { Close } from "@mui/icons-material";
import { Box, ButtonBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InspirationLibraryRoutes } from "../InspirationLibraryHelper";

export const GetInspirationPopup = () => {
  const [showInspirationPopup, setShowInspirationPopup] = useState(false);
  const navigate = useNavigate();

  const handleGoToInspirationPage = () => {
    if (window.location.pathname.includes("suites/video-suite")) {
      navigate(InspirationLibraryRoutes.videoLibrary);
    } else if (window.location.pathname.includes("suites/image-suite")) {
      navigate(InspirationLibraryRoutes.imageLibrary);
    }
  };

  useEffect(() => {
    // On first mount, if not explicitly false, ensure it's set to true
    const stored = localStorage.getItem("showInspirationPopup");
    if (stored === null) {
      localStorage.setItem("showInspirationPopup", "true");
      setShowInspirationPopup(true);
    }
  }, []);

  const handleClosePopup = () => {
    localStorage.setItem("showInspirationPopup", "false");
    setShowInspirationPopup(false); // update state
  };

  return (
    (window.location.pathname.includes("suites/video-suite") ||
      window.location.pathname.includes("suites/image-suite")) &&
    showInspirationPopup && (
      <Box className="get-inspiration-popup">
        <Box className="get-inspiration-popup-header">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              gap: "4px",
            }}
          >
            <img src="/images/InspireLibrary/inspireimage.svg" alt="" />
            <Typography
              sx={{
                fontWeight: "500",
                fontFamily: "Roboto",
                color: "var(--Main_icons_color)",
              }}
            >
              Get Inspired!
            </Typography>
            <img src="/images/InspireLibrary/stars.svg" alt="" />
          </Box>
          <Box>
            <ButtonBase onClick={handleClosePopup}>
              <Close
                sx={{
                  fontSize: "24px",
                }}
              />
            </ButtonBase>
          </Box>
        </Box>
        <Box className="get-inspiration-popup-body">
          <p>Need ideas for your next project!</p>
        </Box>
        <Box
          className="get-inspiration-popup-btn"
          onClick={handleGoToInspirationPage}
        >
          Get Inspiration Now
        </Box>
      </Box>
    )
  );
};
